import React from 'react'
import { TextSM } from '../../../../../Components/Text/NormalText';
import NuAmount from '../../../../../Components/Utils/NuAmount';
import NuDate from '../../../../../Components/Utils/NuDate';
import { Link, useParams } from 'react-router-dom';
import ViewMorePaymentReq from './ViewMore';
import { ActivatePill, CancelPill, CompletePill, HoldPill, OtherPill, ProgressPill, RejectedPill, StartPill } from '../../../../../Components/Utils/StatusPills';

function PaymentReqCard({ item }) {
    const { officeId, projectID } = useParams();
    return (
        <div className=" w-full border  bg-white rounded-lg shadow-xl mt-1.5 mb-2">
            <div className="flex justify-between bg-[#ECEBF3]  rounded-t-lg items-center px-4 py-2">
                <p className=" w-8 h-5 bg-slate-300  flex justify-center font-medium text-mainColor-500 items-center text-[12px] rounded-lg">
                    {item?.id || "#"}
                </p>
                <div className=" flex items-center gap-3">
                    <div className="flex items-center gap-2 overflow-hidden">
                        {item?.biddingStatus &&
                            item?.biddingStatus != "" &&
                            (item?.biddingStatus.toLocaleLowerCase() == "active" ? (
                                <ActivatePill />
                            ) : item?.biddingStatus.toLocaleLowerCase() == "yet-to-start" ||
                                item?.biddingStatus.toLocaleLowerCase() == "yet to start" ? (
                                <StartPill />
                            ) : item?.biddingStatus.toLocaleLowerCase() == "in-progress" ||
                                item?.biddingStatus.toLocaleLowerCase() == "in progress" ? (
                                <ProgressPill />
                            ) : item?.biddingStatus.toLocaleLowerCase() == "on-hold" ||
                                item?.biddingStatus.toLocaleLowerCase() == "on hold" ? (
                                <HoldPill />
                            ) : item?.biddingStatus.toLocaleLowerCase() == "cancel" ||
                                item?.biddingStatus.toLocaleLowerCase() == "canceled" ? (
                                <CancelPill />
                            ) : item?.biddingStatus.toLocaleLowerCase() == "reject" ||
                                item?.biddingStatus.toLocaleLowerCase() == "rejected" ? (
                                <RejectedPill />
                            ) : item?.biddingStatus.toLocaleLowerCase() == "completed" ||
                                item?.biddingStatus.toLocaleLowerCase() == "complete" ? (
                                <CompletePill />
                            ) : (
                                <OtherPill text={item?.biddingStatus} />
                            ))}
                    </div>
                    <ViewMorePaymentReq id={item?.id} getProject={() => { }} data={item} />
                </div>
            </div>
            <div className=" px-2 pb-2">
                <div className=" px-2 w-full h-8 mt-2 truncate  overflow-hidden">
                    <Link
                        className="hover:text-blue-600 text-mainColor-400 font-semibold text-[12px] lg:text-[12px] xl:text-[12px] w-full flex justify-between items-center"
                        to={`/project/procurement/payment-request/${officeId}/${projectID}/view/${item?.poId}`}
                        state={{ data: item }}
                    >
                        {item?.ref || "-"}
                    </Link>
                </div>
                <div
                    className="w-full flex justify-between items-center flex-wrap gap-2 mb-2 rounded-md p-2"
                    style={{ border: "1px solid #C0C0C0" }}
                >
                    <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
                        <div className=" w-full">
                            <TextSM content={"PR :" || "-"} />
                            <div className=" text-xs ">{item?.prRef || "-"}</div>
                        </div>
                    </div>

                    <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
                        <div className=" w-full">
                            <TextSM content={"PO :" || "-"} />
                            <div className=" text-xs ">{item?.poRef || "-"}</div>

                            {/* <div className=" text-xs ">
                                {(item?.date != "None" && (
                                    <NuDate value={item?.date} format="DD-MMM-YY" />
                                )) ||
                                    "-"}
                            </div> */}
                        </div>
                    </div>
                    <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
                        <div className=" w-full">
                            <TextSM content={"Currency :" || "-"} />
                            <div className=" text-xs ">{item?.currency || "-"}</div>

                            {/* <div className=" text-xs ">
                                {(item?.deadLine != "None" && (
                                    <NuDate value={item?.deadLine} format="DD-MMM-YY" />
                                )) ||
                                    "-"}
                            </div> */}
                        </div>
                    </div>
                    <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
                        <div className=" w-full">
                            <TextSM content={"Invoice Amount :" || "-"} />
                            <div className=" text-xs ">
                                <NuAmount value={item?.invoiceAmount || 0} />
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </div>
    );
}

export default PaymentReqCard
